/* eslint-disable no-mixed-spaces-and-tabs */
import { SHIFT_REPORT_LIST, SHIFT_REPORT_ERROR, SHIFT_REPORT_SUCCESS, SHIFT_REPORT_DETAILS, SHIFT_LIST_DETAILS, SHIFT_LIST_DETAILS_ERROR, SHIFT_LIST_DETAILS_SUCCESS, SHIFT_QUESTIONS, SHIFT_QUESTIONS_ERROR, SHIFT_QUESTIONS_SUCCESS, USERS_LIST, USERS_LIST_SUCCESS, USERS_LIST_ERROR } from './constants';

export default function shiftdata(state, action) {

	switch (action.type) {
	  
	case SHIFT_REPORT_LIST:
		return { ...state, pending: true };
	case SHIFT_REPORT_SUCCESS:
		return { ...state, shift_data: action.payload, pending: false };
	case SHIFT_REPORT_DETAILS:
		return { ...state, details: action.payload, pending: false };
	case SHIFT_REPORT_ERROR:
		return { ...state, error: true, pending: false };
	case SHIFT_LIST_DETAILS:
		return { ...state, pending: true };
	case SHIFT_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };
	case SHIFT_LIST_DETAILS_SUCCESS:
		return { ...state, pending: false, details:action.payload, error: false };
	case SHIFT_QUESTIONS:
		return { ...state, pending: true };
	case SHIFT_QUESTIONS_ERROR:
		return { ...state, pending: false, error: true };
	case SHIFT_QUESTIONS_SUCCESS:
		return { ...state, pending: false, questions:action.payload, error: false };

	case USERS_LIST:
		return { ...state, pending: true };
	case USERS_LIST_SUCCESS:
		return { ...state, users_data: action.payload, pending: false };
	case USERS_LIST_ERROR:
		return { ...state, error: true, pending: false };

	  
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}